<template>
    <div class="invoice_box safe-distance-top-header-two">
        <headerCom :pageTitle="headerTitle" />
        <van-cell-group class="invoice_form_group" v-if="isFrom === 'orderDetail' || isFrom === 'invoiceDetail'">
            <van-field label="订单编号">
                <template #input>
                    <p>{{ $route.query.orderId }}</p>
                </template>
            </van-field>
            <van-field label="开票金额">
                <template #input>
                    <p>¥{{ $route.query.invoicePrice }}</p>
                </template>
            </van-field>
        </van-cell-group>
        <van-form class="invoice_form" ref="invoiceForm" @submit="onSubmit">
            <van-cell-group class="invoice_form_group">
                <van-field label="抬头类型">
                    <template #input>
                        <van-radio-group v-model="invoiceInfo.headerType" direction="horizontal" @change="headerTypeChange">
                            <van-radio checked-color="#4A79F1" :name="0">个人</van-radio>
                            <van-radio checked-color="#4A79F1" :name="1">企业</van-radio>
                        </van-radio-group>
                    </template>
                </van-field>
                <van-field label="发票类型">
                    <template #input>
                        <p>增值税普通发票</p>
                    </template>
                </van-field>
                <van-field v-if="invoiceInfo.headerType === 0" v-model.trim="invoiceInfo.personInvoiceHeader"
                    name="personInvoiceHeader" label="发票抬头" placeholder="请输入发票抬头" :rules="[{ required: true, message: '请输入发票抬头' },
                    { pattern: /^.{0,50}$/, message: '发票抬头限制50个字' }]" />
                <van-field v-if="invoiceInfo.headerType === 1" v-model.trim="invoiceInfo.enterpriseInvoiceHeader"
                    name="enterpriseInvoiceHeader" label="发票抬头" placeholder="请输入发票抬头" :rules="[{ required: true, message: '请输入发票抬头' },
                    { pattern: /^.{0,50}$/, message: '发票抬头限制50个字' }]" />
                <van-field v-if="invoiceInfo.headerType === 1" v-model.trim="invoiceInfo.taxpayerNm" name="taxpayerNm"
                    label="纳税人识别号" placeholder="请输入纳税人识别号" :rules="[{ required: true, message: '请输入纳税人识别号' },
                    { pattern: /^[a-zA-Z0-9]{15,20}$/, message: '纳税人识别号限制15-20个数字或字母' }]" />
                <van-field v-if="invoiceInfo.headerType === 1" v-model.trim="invoiceInfo.openingBank" name="openingBank"
                    label="开户银行" placeholder="选填" :rules="[{ pattern: /^.{0,50}$/, message: '开户银行限制50个字' }]" />
                <van-field v-if="invoiceInfo.headerType === 1" v-model.trim="invoiceInfo.bankAccount" name="bankAccount"
                    label="银行账号" placeholder="选填"
                    :rules="[{ validator: bankAccountValidator, message: '银行账号限制10-30个数字' }]" />
                <van-field v-if="invoiceInfo.headerType === 1" v-model.trim="invoiceInfo.unitAddr" name="unitAddr"
                    label="注册地址" placeholder="选填" :rules="[{ pattern: /^.{0,50}$/, message: '注册地址限制50个字' }]" />
                <van-field v-if="invoiceInfo.headerType === 1" v-model.trim="invoiceInfo.unitPhone" name="unitPhone"
                    label="注册电话" placeholder="选填" :rules="[{ validator: unitPhoneValidator, message: '注册电话限制8-11个数字' }]" />
            </van-cell-group>
            <div class="invoice_form_btn_box">
                <van-button class="invoice_form_btn" round block :loading="formLoading" type="info" native-type="submit">{{
                    btnText }}</van-button>
            </div>
        </van-form>
    </div>
</template>

<script>
import { Toast } from "vant";
import Header from "@/views/mobileView/components/header";
export default {
    name: "Invoice",
    components: {
        'headerCom': Header,
    },
    data() {
        return {
            isFrom: "",
            invoiceInfo: {
                headerType: 0,
                invoiceType: 0,
                personInvoiceHeader: "",
                enterpriseInvoiceHeader: "",
                taxpayerNm: "",
                openingBank: "",
                bankAccount: "",
                unitAddr: "",
                unitPhone: "",
            },
            formLoading: false,
        }
    },
    created() {
        this.isFrom = this.$route.query.from
        if (this.isFrom === 'invoiceDetail') {
            this.getAgainInvoice()
        } else if (this.isFrom === 'orderConfirm' && sessionStorage.getItem("userInvoiceInfo")) {
            this.getOrderConfirmInvoice()
        } else {
            this.getInvoice()
        }
    },
    computed: {
        headerTitle() {
            switch (this.isFrom) {
                case 'orderDetail':
                    return '申请发票';
                case 'invoiceDetail':
                    return '重新开票';
                case 'orderConfirm':
                    return '开具发票';
                default:
                    return '发票抬头';
            }
        },
        btnText() {
            switch (this.isFrom) {
                case 'orderDetail':
                case 'invoiceDetail':
                    return '提交申请';
                default:
                    return '确定';
            }
        },
    },
    methods: {
        headerTypeChange() {
            this.$refs.invoiceForm.resetValidation()
        },
        getOrderConfirmInvoice() {
            if (sessionStorage.getItem("userInvoiceInfo")) {
                let invoiceInfoObj = JSON.parse(sessionStorage.getItem("userInvoiceInfo"));
                for (const key in this.invoiceInfo) {
                    this.invoiceInfo[key] = invoiceInfoObj[key]
                }
                if (invoiceInfoObj.headerType === 1) {
                    this.invoiceInfo.enterpriseInvoiceHeader = invoiceInfoObj.invoiceHeader
                } else {
                    this.invoiceInfo.personInvoiceHeader = invoiceInfoObj.invoiceHeader
                }
            }
        },
        async getAgainInvoice() {
            const res = await this.$apis.invoiceServe.getInvoiceStatus({
                id: this.$route.query.orderInvoiceId
            })
            if (res.resultCode === '200') {
                for (const key in this.invoiceInfo) {
                    this.invoiceInfo[key] = res.data[key]
                }
                if (res.data.headerType === 1) {
                    this.invoiceInfo.enterpriseInvoiceHeader = res.data.invoiceHeader
                } else {
                    this.invoiceInfo.personInvoiceHeader = res.data.invoiceHeader
                }
            }
        },
        async getInvoice() {
            const res = await this.$apis.invoiceServe.getInvoiceInfo()
            if (res.resultCode === '200') {
                for (const key in this.invoiceInfo) {
                    this.invoiceInfo[key] = res.data[key]
                }
                if (res.data.headerType === 1) {
                    this.invoiceInfo.enterpriseInvoiceHeader = res.data.invoiceHeader
                } else {
                    this.invoiceInfo.personInvoiceHeader = res.data.invoiceHeader
                }
            }
        },
        async onSubmit() {
            this.formLoading = true
            let obj = {}
            for (const key in this.invoiceInfo) {
                if (this.invoiceInfo.headerType === 0) {
                    if (key === 'headerType' || key === 'invoiceType') {
                        obj[key] = this.invoiceInfo[key]
                    } else if (key === 'personInvoiceHeader') {
                        obj.invoiceHeader = this.invoiceInfo[key]
                    }
                } else if (this.invoiceInfo.headerType === 1) {
                    if (key === 'enterpriseInvoiceHeader') {
                        obj.invoiceHeader = this.invoiceInfo[key]
                    } else if (key !== 'personInvoiceHeader') {
                        obj[key] = this.invoiceInfo[key]
                    }
                }
            }
            if (this.isFrom === 'orderDetail' || this.isFrom === 'invoiceDetail') {
                Object.assign(obj, this.$route.query)
                delete obj.from
                delete obj.orderInvoiceId
                console.log(obj, 'obj');
                const res = await this.$apis.invoiceServe.applyInvoice(obj)
                if (res.resultCode === '200') {
                    Toast('提交成功')
                    if (this.isFrom === 'invoiceDetail') {
                        this.$router.go(-2)
                    } else {
                        this.$router.go(-1)
                    }
                } else {
                    Toast(res.resultDesc)
                }
            } else if (this.isFrom === 'orderConfirm') {
                sessionStorage.setItem('userInvoiceInfo', JSON.stringify(obj))
                this.$router.go(-1)
            } else {
                const res = await this.$apis.invoiceServe.saveInvoiceInfo(obj)
                if (res.resultCode === '200') {
                    Toast('保存成功')
                    this.getInvoice()
                } else {
                    Toast(res.resultDesc)
                }
            }
            this.formLoading = false
        },
        bankAccountValidator(val) {
            if (val !== '') {
                return /^\d{10,30}$/.test(val);
            }
            return true
        },
        unitPhoneValidator(val) {
            if (val !== '') {
                return /^\d{8,11}$/.test(val);
            }
            return true
        },
    },
}
</script>

<style lang='scss' scoped>
.invoice_box {
    width: 100vw;
    min-height: 100vh;
    background: #f5f5f5;
    overflow: hidden;



    .invoice_form {
        padding-bottom: 80px;


        .invoice_form_group {
            &::v-deep .van-field--error {
                .van-field__control {
                    &::placeholder {
                        color: #ccc;
                    }
                }
            }
        }

        .invoice_form_btn_box {
            position: fixed;
            bottom: 0;
            left: 0;
            padding: 5px 15px 0;
            padding-bottom: calc(constant(safe-area-inset-bottom) + 10px) !important;
            padding-bottom: calc(env(safe-area-inset-bottom) + 10px) !important;
            width: 100%;
            background-color: #fff;

            .invoice_form_btn {
                margin: 0 auto;
                width: 345px;
                height: 44px;
                background-color: #4A79F1;
            }
        }

    }
}
</style>